const PlaceRoute = [
    {
        path: "/Place",
        name: "PlaceIndex",
        component: () =>
            import(/* webpackChunkName: "Place" */ "./PlaceIndex.vue"),
    },
];
export default PlaceRoute;
